import React from "react";
import { useNavigate } from "react-router-dom";
import { CoreButton } from "../components/komodo";
import { getString } from "../utils/localizationHelper";
import "./Home.scss";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="tf-page tf-home">
      <div className="tf-container">
        <div className="tf-row">
          <div className="tf-col-xs-12 tf-col-sm-6 tf-home-title">
            <h1 className="tf-h-h">{getString("home.title")}</h1>
            <p className="tf-h-s">{getString("home.subtitle")}</p>
          </div>
          <div className="tf-col-xs-12 tf-col-sm-6 tf-home-img-wrapper">
            <div className="tf-home-img">
              <img
                src={process.env.PUBLIC_URL + "/assets/elisa-home.png"}
                alt="ELISA Builder"
              />
            </div>
          </div>
          <div className="tf-col-xs-12 tf-col-md-6">
            <div className="tf-about-card">
              <p>{getString("home.about.title")}</p>
              <CoreButton
                variant="primary"
                size="medium"
                type="button"
                onClick={() => navigate("/quiz")}
                aria-label="Start the ELISA Builder quiz"
              >
                <span slot="content">{getString("home.about.get_started")}</span>
              </CoreButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
